"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isFieldValueWrapper = isFieldValueWrapper;
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _FieldValue = _interopRequireDefault(require("./FieldValue"));

var _default = _propTypes.default.shape({
  // A raw field value, like 'I am a raw result', or 2, or true. Raw values may
  // or may not be html escaped, so *always* sanitize a raw value before rendering
  // it on a page as html.
  raw: _FieldValue.default,
  // A snippet value contains a highlighted value. I.e., 'I <em>am</em> a raw
  // result'. These are always sanitized and safe to render as html.
  snippet: _propTypes.default.string
});

exports.default = _default;

function isFieldValueWrapper(object) {
  return object && (object.hasOwnProperty("raw") || object.hasOwnProperty("snippet"));
}